import React from "react";
import IconNone from "../../icons/toolbar/menu/crop/NoFrame";

export const FRAME_TYPE_NONE = "none"
export const FRAME_TYPE_DARK_FRAME = "darkframe"
export const FRAME_TYPE_POLAROID = "polaroid"

const FRAME_NONE = {
  id: 1,
  icon: "none",
  text: "None",
  className: null,
  type: FRAME_TYPE_NONE
}

const FRAME_DARK_FRAME = {
  id: 2,
  icon: "plain-black",
  text: "Plain Black",
  className: "frame plain-black darkframe",
  type: FRAME_TYPE_DARK_FRAME,
}

const FRAME_POLAROID = {
  id: 3,
  icon: "polaroid",
  text: "Polaroid",
  className: "frame polaroid",
  type: FRAME_TYPE_POLAROID,
}

const FRAMES = [
  FRAME_NONE,
  FRAME_DARK_FRAME,
  FRAME_POLAROID
]

const FrameMenu = (props) => {

  let {
    frame,
    onFrameUpdated,
    originalImage
  } = props;

  return (
    <div className="frame-menu">
      {
        FRAMES.map(frameObj => {
          let className = frameObj.icon + " "
          className += (frame === frameObj.type) ? "active" : ""

          let isNone = frameObj.icon === "none"
          return (
            <div
              key={frameObj.id}
              className={`item ${className}`}
              onClick={() => onFrameUpdated(frameObj.type)}
            >
              <div className={`asset ${frameObj.icon}`}>
                {
                  isNone ? (
                    <IconNone />
                  ) : (
                    <img alt={frameObj.text} src={originalImage} style={{objectFit: "cover"}} />
                  )
                }
              </div>
              <span>
                {frameObj.text}
              </span>
            </div>
          )
        })
      }
    </div>
  );
}

export default FrameMenu
